document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".js-socialMv__img");

  if (images.length === 0) return; // 要素が存在しない場合は処理を中断

  function checkImages() {
      const windowHeight = window.innerHeight;
      const windowMiddle = windowHeight / 2;

      images.forEach(img => {
          const rect = img.getBoundingClientRect();
          const imgMiddle = rect.top + rect.height / 2;

          if (imgMiddle >= windowMiddle - 50 && imgMiddle <= windowMiddle + 50) {
              img.classList.add("is_active");
          }
      });
  }

  window.addEventListener("scroll", checkImages);
  checkImages();
});
